module.exports = __webpack_public_path__ + "static/media/myphoto9.71c618d1.jpg";